export const states = [
  ["Alabama", "AL"],
  ["Alaska", "AK"],
  ["Arizona", "AZ"],
  ["Arkansas", "AR"],
  ["California", "CA"],
  ["Colorado", "CO"],
  ["Connecticut", "CT"],
  ["Delaware", "DE"],
  ["District Of Columbia", "DC"],
  ["Florida", "FL"],
  ["Georgia", "GA"],
  ["Hawaii", "HI"],
  ["Idaho", "ID"],
  ["Illinois", "IL"],
  ["Indiana", "IN"],
  ["Iowa", "IA"],
  ["Kansas", "KS"],
  ["Kentucky", "KY"],
  ["Louisiana", "LA"],
  ["Maine", "ME"],
  ["Maryland", "MD"],
  ["Massachusetts", "MA"],
  ["Michigan", "MI"],
  ["Minnesota", "MN"],
  ["Mississippi", "MS"],
  ["Missouri", "MO"],
  ["Montana", "MT"],
  ["Nebraska", "NE"],
  ["Nevada", "NV"],
  ["New Hampshire", "NH"],
  ["New Jersey", "NJ"],
  ["New Mexico", "NM"],
  ["New York", "NY"],
  ["North Carolina", "NC"],
  ["North Dakota", "ND"],
  ["Ohio", "OH"],
  ["Oklahoma", "OK"],
  ["Oregon", "OR"],
  ["Pennsylvania", "PA"],
  ["Rhode Island", "RI"],
  ["South Carolina", "SC"],
  ["South Dakota", "SD"],
  ["Tennessee", "TN"],
  ["Texas", "TX"],
  ["Utah", "UT"],
  ["Vermont", "VT"],
  ["Virginia", "VA"],
  ["Washington", "WA"],
  ["West Virginia", "WV"],
  ["Wisconsin", "WI"],
  ["Wyoming", "WY"],
];

export const abbrState = (input, to = "abbr") => {
  // var states = [
  //   ["Alabama", "AL"],
  //   ["Alaska", "AK"],
  //   ["Arizona", "AZ"],
  //   ["Arkansas", "AR"],
  //   ["California", "CA"],
  //   ["Colorado", "CO"],
  //   ["Connecticut", "CT"],
  //   ["Delaware", "DE"],
  //   ["District Of Columbia", "DC"],
  //   ["Florida", "FL"],
  //   ["Georgia", "GA"],
  //   ["Hawaii", "HI"],
  //   ["Idaho", "ID"],
  //   ["Illinois", "IL"],
  //   ["Indiana", "IN"],
  //   ["Iowa", "IA"],
  //   ["Kansas", "KS"],
  //   ["Kentucky", "KY"],
  //   ["Louisiana", "LA"],
  //   ["Maine", "ME"],
  //   ["Maryland", "MD"],
  //   ["Massachusetts", "MA"],
  //   ["Michigan", "MI"],
  //   ["Minnesota", "MN"],
  //   ["Mississippi", "MS"],
  //   ["Missouri", "MO"],
  //   ["Montana", "MT"],
  //   ["Nebraska", "NE"],
  //   ["Nevada", "NV"],
  //   ["New Hampshire", "NH"],
  //   ["New Jersey", "NJ"],
  //   ["New Mexico", "NM"],
  //   ["New York", "NY"],
  //   ["North Carolina", "NC"],
  //   ["North Dakota", "ND"],
  //   ["Ohio", "OH"],
  //   ["Oklahoma", "OK"],
  //   ["Oregon", "OR"],
  //   ["Pennsylvania", "PA"],
  //   ["Rhode Island", "RI"],
  //   ["South Carolina", "SC"],
  //   ["South Dakota", "SD"],
  //   ["Tennessee", "TN"],
  //   ["Texas", "TX"],
  //   ["Utah", "UT"],
  //   ["Vermont", "VT"],
  //   ["Virginia", "VA"],
  //   ["Washington", "WA"],
  //   ["West Virginia", "WV"],
  //   ["Wisconsin", "WI"],
  //   ["Wyoming", "WY"],
  // ];

  if (to === "abbr") {
    input = input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });

    for (let i = 0; i < states.length; i++) {
      if (states[i][0] === input) {
        return states[i][1];
      }
    }
  } else if (to === "name") {
    input = input.toUpperCase();
    for (let i = 0; i < states.length; i++) {
      if (states[i][1] === input) {
        return states[i][0];
      }
    }
  }
};

export const normalize = (string) => {
  return string != null ? string.trim().toLowerCase() : "";
};

export const sort = (arr) => {
  return arr.sort((a, b) => {
    // Convert both values to strings and compare
    return a.localeCompare(b, undefined, { numeric: true });
  });
};

export const filterDistricts = (
  activeSearchTerm,
  activeFilters,
  districtData,
  mea
) => {
  if (!districtData) return districtData;

  const awardDistricts = [
    ...new Set(
      mea.map((district) => {
        return district["School District"];
      })
    ),
  ];

  if (activeSearchTerm === "" && activeFilters.length === 0) {
    return districtData;
  }

  let filtered = districtData.features;

  const searchTerm = activeSearchTerm.toLowerCase();
  if (searchTerm !== "") {
    filtered = filtered.filter((x) => {
      return (
        x.properties.name.toLowerCase().includes(searchTerm) ||
        x.properties.name.toLowerCase().includes(searchTerm) ||
        x.properties.name.toLowerCase().includes(searchTerm)
      );
    });
  }

  filtered = filtered.filter((district) =>
    awardDistricts.includes(district.properties.name)
  );

  if (activeFilters.aoi.length > 0) {
    filtered = filtered.filter(function (x) {
      const awards = mea.filter((award) => {
        return award["School District"] === x.properties.name;
      });

      const aoiCategories = sort([
        ...new Set(
          awards.map((award) => award["AOI"]).filter((val) => val !== "")
        ),
      ]);

      console.log(aoiCategories);

      if (
        aoiCategories.length === 0 &&
        activeFilters.aoi.indexOf(" ") > -1
      ) {
        return true;
      }

      return aoiCategories.some((x) => {
        return activeFilters.aoi.indexOf(
          x
        ) > -1;
      })
    });
  }

  if (activeFilters.decarbonizingTechnology.length > 0) {
    filtered = filtered.filter(function (x) {
      const awards = mea.filter((award) => {
        return award["School District"] === x.properties.name;
      });

      const decarbonizingTechnology = sort([
        ...new Set(
          awards
            .map((award) => award["Decarbonizing PROJECT"])
            .filter((val) => val !== "")
        ),
      ]);

      if (
        decarbonizingTechnology.length === 0 &&
        activeFilters.decarbonizingTechnology.indexOf(" ") > -1
      ) {
        return true;
      }

      return decarbonizingTechnology?.some((x) => {
        return activeFilters.decarbonizingTechnology.indexOf(
          x
        ) > -1;
      })
    });
  }

  if (activeFilters.awardYear.length > 0) {
    filtered = filtered.filter(function (x) {
      const awards = mea.filter((award) => {
        return award["School District"] === x.properties.name;
      });

      const awardYears = sort([
        ...new Set(
          awards.map((award) => award["Fiscal Year(s)"]).filter((val) => val !== "")
        ),
      ]);

      if (
        awardYears.length === 0 &&
        activeFilters.awardYear.indexOf(" ") > -1
      ) {
        return true;
      }

      return awardYears.some((x) => {
        return activeFilters.awardYear.indexOf(
          x
        ) > -1;
      })
    });
  }

  const filteredDistricts = JSON.parse(JSON.stringify(districtData));
  filteredDistricts.features = filtered;

  return filteredDistricts;
};

export const filterSchools = (activeSearchTerm, activeFilters, schoolsData) => {
  if (activeSearchTerm === "" && activeFilters.length === 0) {
    return schoolsData;
  }
  let filtered = schoolsData;
  const searchTerm = activeSearchTerm.toLowerCase();
  if (searchTerm !== "") {
    filtered = filtered.filter((x) => {
      return (
        x.properties.title_search.includes(searchTerm) ||
        x.properties.subTitle_search.includes(searchTerm) ||
        x.properties.city_search.includes(searchTerm)
      );
    });
  }

  if (activeFilters.funding.length > 0) {
    filtered = filtered.filter(function (x) {
      if (
        x.properties.funding === "" &&
        activeFilters.funding.indexOf(" ") > -1
      ) {
        return true;
      }
      return activeFilters.funding.indexOf(x.properties.fundingSubtype) > -1;
    });
  }

  if (activeFilters.structureType.length > 0) {
    filtered = filtered.filter(function (x) {
      if (
        x.properties.structureType === "" &&
        activeFilters.structureType.indexOf(" ") > -1
      ) {
        return true;
      }
      return (
        activeFilters.structureType.indexOf(x.properties.structureType) > -1
      );
    });
  }

  if (activeFilters.systemSize.length > 0) {
    filtered = filtered.filter(function (x) {
      return activeFilters.systemSize.some(function (y) {
        var systemSize =
          parseInt(x.properties.systemSize) || x.properties.systemSize;
        if (systemSize == null) {
          return false;
        }
        if (
          y === "* Powered by a district array" &&
          systemSize === "* Powered by a district array"
        ) {
          return true;
        }
        if (y === "0-14.99" && systemSize < 15) {
          return true;
        }
        if (y === "15-49.99" && systemSize >= 15 && systemSize <= 49.99) {
          return true;
        }
        if (y === "50-199.99" && systemSize >= 50 && systemSize <= 199.99) {
          return true;
        }
        if (y === "200-499.99" && systemSize >= 200 && systemSize <= 499.99) {
          return true;
        }
        if (y === "500" && systemSize >= 3500) {
          return true;
        }
        if (y === "solar-hot-water-heater" && systemSize === "SH&C") {
          return true;
        }
        return false;
      });
    });
  }

  if (activeFilters.cleanEnergyTechnology.length > 0) {
    filtered = filtered.filter(function (x) {
      return activeFilters.cleanEnergyTechnology.some(function (y) {
        var cleanEnergyTechnology =
          parseInt(x.properties.cleanEnergyTechnology) || x.properties.cleanEnergyTechnology;
        if (cleanEnergyTechnology == null) {
          return false;
        }
        if (
          y === "Solar" &&
          cleanEnergyTechnology === "Solar"
        ) {
          return true;
        }
        if (
          y === "Solar + Battery Storage" &&
          cleanEnergyTechnology === "Solar + Battery Storage"
        ) {
          return true;
        }
        return false;
      });
    });
  }

  if (activeFilters.caseStudies.length > 0) {
    filtered = filtered.filter(function (x) {
      return x.properties.pin_type === "Case Study";
    });
  }

  if (activeFilters.batteryStorage.length === 0) {
    filtered = filtered.filter(function (x) {
      return x.properties.batteryStorage !== true;
    });
  }

  return filtered;
};

export const filterSchoolsByPinType = (schoolsData, pinType) => {
  return schoolsData.filter((x) => {
    return x.properties?.pin_type === pinType;
  });
};

export const filterSchoolsByState = (schoolsData, stateCode) => {
  return schoolsData.filter((x) => {
    return x.properties?.state === stateCode;
  });
};
